export const phoneMask = (value) => {
  if (!value) return '';
  
  // Remove tudo que não é dígito
  value = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  if (value.length > 11) value = value.slice(0, 11);
  
  // Aplica a máscara (XX) XXXXX-XXXX
  value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
  value = value.replace(/(\d)(\d{4})$/, '$1-$2');
  
  return value;
};

export const cepMask = (value) => {
  if (!value) return '';
  
  // Remove tudo que não é dígito
  value = value.replace(/\D/g, '');
  
  // Limita a 8 dígitos
  if (value.length > 8) value = value.slice(0, 8);
  
  // Aplica a máscara XXXXX-XXX
  value = value.replace(/^(\d{5})(\d)/, '$1-$2');
  
  return value;
};

export const currencyMask = (value) => {
  if (!value) return '';
  
  // Remove tudo que não é dígito
  value = value.replace(/\D/g, '');
  
  // Converte para moeda
  const number = Number(value) / 100;
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
